export default __webpack_public_path__ + "static/media/property_956.e82f5fb5.png";